<div id="general-filters">

  <div class="row">
    <p class="title">Filtros gerais</p>
    <a class="clean-filters">Limpar</a>
  </div>

  <div class="row">
    <app-input id="ref-imovel" class="one-third" label="Ref. imóvel" placeholder="">
    </app-input>
    <app-input id="ref-imovel-legado" class="one-third" label="Ref. imóvel sistema legado" placeholder="">
    </app-input>
    <app-input id="fac-id" id="" class="one-third" label="Nº da fac ou nome do cliente" placeholder="">
    </app-input>
  </div>

  <div class="row">
    <div class="one-third col-1">
      <label>Buscar em</label>
      <lib-input-checkbox id="meus-imoveis" class="item-action" label="Meus Imóveis"></lib-input-checkbox>
      <lib-input-checkbox id="minha empresa" class="item-action" label="Minha Empresa"></lib-input-checkbox>
    </div>
    <div class="one-third col-2">
      <label>Status</label>
      <lib-input-checkbox id="ativo" class="item-action" label="Ativo"></lib-input-checkbox>
      <lib-input-checkbox id="suspenso" class="item-action" label="Suspenso"></lib-input-checkbox>
      <lib-input-checkbox id="baixado" class="item-action" label="Baixado"></lib-input-checkbox>
      <lib-input-checkbox id="pre-cadastro" class="item-action" label="Pré-cadastro"></lib-input-checkbox>
      <lib-input-checkbox id="provisorio" class="item-action" label="Provisório"></lib-input-checkbox>
    </div>
    <div class="one-third col-3">
      <label>Estágio</label>
      <lib-input-checkbox id="lancamento" class="item-action" label="Lançamento"></lib-input-checkbox>
      <lib-input-checkbox id="breve-lancamento" class="item-action" label="Breve lançamento"></lib-input-checkbox>
      <lib-input-checkbox id="pronto" class="item-action" label="Pronto"></lib-input-checkbox>
    </div>
  </div>
</div>